// extracted by mini-css-extract-plugin
export default {"root":"gFd5ORN","icon":"yRuBydl"};